export default defineNuxtRouteMiddleware((to, from) => {
  const isTablet = useState<boolean>('isTablet');
  const deviceType = useState('deviceType');

  if (deviceType.value === 'desktop') {
    if (to.path.startsWith('/catalog/menu/')) {
      return navigateTo('/catalog', { redirectCode: 301 });
    }

    if (to.name === 'cabinet') {
      return navigateTo('/cabinet/orders', { redirectCode: 301 });
    }
  }
});
